export default "__VITE_ASSET__49b6a48e__"